// Mock data for FERAL Tribe clone

export const navLinks = [
  { label: "EVENTS & RETREATS", to: "/events" },
  { label: "FERAL STAYS", to: "/stays" },
  { label: "VENUE HIRE", to: "/venue-hire" },
  { label: "UNBOUND", to: "/unbound" },
  { label: "OUR STORY", to: "/our-story" },
];

export const heroSlides = [
  { image: "/hero-community.jpg", alt: "FERAL community gathering" },
  { image: "/hero-laughing.jpg", alt: "People laughing together" },
  { image: "/hero-interior.jpg", alt: "FERAL manor interior" },
  { image: "/hero-goat.jpg", alt: "A resident FERAL goat" },
  { image: "/hero-pineapple.jpg", alt: "Feast details" },
];

export const heroContent = {
  title: ["BE FREE,", "BE FERAL."],
  subtitle: "FERAL Collective",
  tagline: "Be Free, Be FERAL.",
};

export const whyFeral = {
  eyebrow: "Be Free, Be FERAL.",
  heading: "Something very special has started in North Wales.",
  paragraphs: [
    "A movement. Where we live a life untamed, stop playing small and unlock our wildest potential together. Community, wellbeing, entrepreneurial energy all hosted in our very own beautiful venues.",
  ],
};

export const stats = [
  {
    value: "3",
    label: "Owned estates on Anglesey with location expansion plans",
  },
  {
    value: "22",
    label: "Peer-reviewed studies underpin the method",
  },
  {
    value: "4",
    label: "Stage Methodology: Regulate • Reconnect • Rewild • Rise",
  },
];

export const feralMethod = {
  eyebrow: "THE FERAL METHOD",
  headingLine1: "Four-stage cycle.",
  headingLine2: "Grounded in science.",
  intro:
    "22 peer-reviewed scientific studies. Woven through every Tribe event, every session, every gathering so that being part of FERAL, you are moving through a cycle with purpose.",
  stages: [
    {
      number: "1",
      title: "REGULATE",
      desc: "GROUND THE NERVOUS SYSTEM. CREATE THE CONDITIONS TO RECONNECT WITH YOURSELF.",
    },
    {
      number: "2",
      title: "RECONNECT",
      desc: "RETURN TO YOURSELF, TO OTHERS, TO THE NATURAL WORLD YOU CAME FROM.",
    },
    {
      number: "3",
      title: "REWILD",
      desc: "MOVE, BREATHE, FEAST, GATHER. REMEMBER WHO YOU ARE.",
    },
    {
      number: "4",
      title: "RISE",
      desc: "TAKE WHAT YOU HAVE INTEGRATED AND MOVE FORWARD WITH CLARITY AND PURPOSE.",
    },
  ],
};

export const upcomingEvents = {
  eyebrow: "WHAT'S COMING UP",
  heading: "UPCOMING EVENTS",
  intro:
    "From retreats and member gatherings to community initiatives and shared experiences.",
  introBold: "Find your way in.",
  events: [
    {
      image:
        "/legacy/_instagramPost/3516/Feral-Retreat-237_WR.webp",
      tag: "Open to all",
      category: "Empowerment Festival",
      title: "FERAL Fest",
      description:
        "A full-site FERAL takeover at Bron Menai for the Autumn Equinox. Gather with us at our country manor house in Newborough for a seasonal day of movement, breath, sound, cacao, good food, local makers and early autumn ritual. Line-up to be announced.",
      dates: "19th September to 20th September '26",
      location: "Newborough",
    },
  ],
  comingSoon: "Events Coming Soon",
};

export const meetTom = {
  image:
    "/legacy/_landscape169/3430/Feral-Retreat-124_WR.webp",
  name: "Meet Tom.",
  role: "FERAL Founder and Lead Dreamer",
  desc: "Tom wants to help people overcome limiting beliefs by connecting with their authentic self, community, and nature.",
};

export const venues = {
  eyebrow: "WHERE WE MEET",
  heading: "Three owned estates. One Island.",
  intro:
    "We do not hire spaces. We own them. Every venue is built for depth, designed for transformation and rooted in the wild Anglesey landscape.",
  estates: [
    {
      image:
        "/bron-menai.jpeg",
      name: "Bron Menai",
      location: "Newborough",
      desc: "A fully renovated country manor set within eight acres of unspoilt Anglesey landscape. The manor sleeps 15, with additional cottages bringing capacity to 23. Designed to host everything from corporate stays to deep retreat work, it offers generous living spaces, indoor and outdoor dining, and a newly built, light-filled studio set within the walled garden. A wellness suite with sauna, cold plunge, hot tub and a quiet Zen den for treatments supports rest, focus and reset. Positioned four miles from Anglesey's famous Newborough beach and forest.",    },
    {
      image:
        "/plas-exterior.jpeg",
      name: "Plas Llechylched",
      location: "Rhosneigr",
      desc: "A historic courtyard estate reimagined by FERAL. Private cottages, shared spaces and 20 bedrooms anchored by log fires, hot tubs and slow, communal living. Set moments from wild beaches and open fields, with uninterrupted horizons and cinematic sunsets. Rustic spa rituals, outdoor feasting, fire pits and a wild pond invite you to switch off. Roamed by our resident goats, the FERAL Mowers, this is a place to gather, reset and reconnect.",
    },
    {
      image:
        "/cymyran-exterior.png",
      name: "Hotel Cymyran",
      location: "Holyhead",
      desc: "The future home of FERAL on a larger scale. Currently undergoing transformation, Cymyran is being reimagined as a flagship hub for wellness, creativity and community. Plans include a spa and wellness complex with wild swimming pool, food hall and artisan market, and a series of event studios and collaborative spaces. Designed to bring people together through nature, culture and shared experience, this is where the next chapter of FERAL begins.",
    },
  ],
  cta: "Find out more",
};

export const gallery = [
  "/legacy/_landscape169/4515/Photo-3.webp",
  "/legacy/_landscape169/4354/DSC2939.webp",
  "/legacy/_landscape169/4355/DSC2943.webp",
  "/legacy/_landscape169/4356/DSC4461.webp",
  "/legacy/_landscape169/4357/DSC4734.webp",
  "/legacy/_landscape169/4358/Feral-Retreat-3_WR_2026-03-19-150724_dpim.webp",
  "/legacy/_landscape169/4359/Feral-Retreat-26_WR_2026-03-19-150725_jmhb.webp",
  "/legacy/_landscape169/4360/Feral-Retreat-85_WR_2026-03-19-150727_cmlw.webp",
  "/legacy/_landscape169/4361/Feral-Retreat-125_WR_2026-03-19-150728_yifw.webp",
  "/legacy/_landscape169/4362/Feral-Retreat-140_WR_2026-03-19-150730_nivn.webp",
  "/legacy/_landscape169/4363/Feral-Retreat-153_WR_2026-03-19-150731_dpmp.webp",
  "/legacy/_landscape169/4364/Feral-Retreat-163_WR_2026-03-19-150732_otwl.webp",
];

export const islandCta = {
  image: "/hero-community.jpg",
  heading: "Be Free, Be FERAL.",
  intro2:
    "The community, the events, the magical venues, FERAL has started something very special in North Wales.",
  primaryCta: "Browse Events",
  secondaryCta: "Help us unlock Feral's potential",
};

export const newsletter = {
  heading: "Keep up to date with everything from FERAL.",
  intro:
    "Want to know more about Feral? Sign up and you'll be among the first to know.",
  consent:
    "I understand that I am agreeing to receive information from FERAL regarding The Tribe.",
};

export const footer = {
  tagline: "Be Free, Be FERAL.",
  location: "Anglesey, North Wales",
  social: {
    instagram: "https://www.instagram.com/weareferalcollective?mdxt=MTVydWJtNHlibGsx",
    facebook: "https://www.facebook.com/findyourferal.co",
  },
  columns: [
    {
      title: "Explore",
      links: [
        { label: "Events", href: "/events" },
        { label: "The Team", href: "/the-team" },
        { label: "Venues", href: "/#venues" },
        { label: "The Method", href: "/#method" },
      ],
    },
    {
      title: "Connect",
      links: [
        { label: "hello@findyourferal.co", href: "mailto:hello@findyourferal.co" },
        { label: "Register Interest", href: "/earn-and-enjoy" },
      ],
    },
  ],
  copyright: "© 2026 FERAL Collective. All rights reserved.",
};

// ---- FERAL Fest event + booking data ----

export const feralFest = {
  slug: "feral-fest",
  name: "FERAL Fest",
  subtitle: "Autumn Equinox",
  dateLine: "Saturday 19th September to 20th September '26",
  time: "10:00 \u2013 20:00",
  venue: "Bron Menai, Newborough",
  priceFrom: "From \u00a375.00 \u00b7 1st Release Sunday",
  ageNote: "This event is strictly 18+.",
  accommodationNote: "",
  limitedNote:
    "Our first FERAL Fest sold out, and spaces for Autumn Equinox are limited.",
  images: [
    "/bron-menai.jpeg",
    "/studio.jpeg",
  ],
  description: [
    "As Summer softens into Autumn, FERAL Fest returns for its next chapter \u2014 this time as a full weekend gathering at Bron Menai, our peaceful country manor house with mountain views, close to Newborough beach and forests.",
    "After the sold-out success of our first FERAL Fest, Summer Solstice, we're taking everything people loved about that day and expanding it into something bigger, richer and more immersive. This time we will have more time to connect, relax, explore the markets and book onto additional workshops, treatments and sauna/spa area.",
    "Set within 8 acres of birdsong, red squirrels, vast lawns, walled gardens, woodland, a beautiful yoga studio, supper club spaces and the warmth of the Manor House itself, FERAL Fest Autumn Equinox is an invitation to gather at the turning point of the season.",
    "This time, you can also stay with us for the full weekend. Accommodation is available on site in the Manor House, cottages, glamping bell tents and motorhome pitches, so you can fully immerse yourself rather than rushing home at the end of the day.",
    "Come for one day, or stay for the whole weekend. However you join us, this is your invitation to mark the shift in season with us \u2014 to gather, ground, feast, move, breathe, listen, create and reconnect.",
  ],
  method: [
    {
      stage: "Regulate",
      text: "Slowing down and grounding the nervous system. Soundbaths in our Regulate Studio.",
    },
    {
      stage: "Reconnect",
      text: "Returning to yourself and others. Breathwork and meditation in the Reconnect Tent.",
    },
    {
      stage: "Rewild",
      text: "Where the energy rises. Movement and cacao in the Rewild zone.",
    },
    {
      stage: "Rise",
      text: "Taking what you've felt and moving forward with clarity and purpose. Key guest speakers and deep discussion in RISE.",
    },
  ],
};

const ticketBlurb =
  "Full access to the FERAL Fest programme \u2014 movement, breath, sound, cacao, seasonal food, makers markets and ritual.";

export const dayTickets = [
  { id: "pre", name: "Pre-release", price: 45, unit: "Person", soldOut: true, desc: ticketBlurb },
  { id: "1st-sat", name: "1st Release Saturday", price: 55, unit: "Person", soldOut: true, desc: ticketBlurb },
  { id: "1st-sun", name: "1st Release Sunday", price: 55, unit: "Person", desc: ticketBlurb },
  { id: "2nd-sat", name: "2nd Release Saturday", price: 65, unit: "Person", desc: ticketBlurb },
  { id: "2nd-sun", name: "2nd Release Sunday", price: 65, unit: "Person", comingSoon: true, desc: ticketBlurb },
];

export const weekendTickets = [
  { id: "wknd-1st", name: "1st Release Weekend \u2014 Saturday & Sunday", price: 85, unit: "Person", soldOut: true, desc: "Two-day access across the full weekend. Unlocks on-site accommodation add-ons." },
  { id: "wknd-2nd", name: "2nd Release Weekend \u2014 Saturday & Sunday", price: 95, unit: "Person", desc: "Two-day access across the full weekend. Unlocks on-site accommodation add-ons." },
];

const L32 = "/legacy/_landscape32/";
const EXT12 =
  "/legacy/_landscape2391/14875/8595794-exterior12-800-1.webp";
const EXT36 =
  "/legacy/_landscape2391/14897/8595794-exterior36-800_2026-06-22-165222_udgz.webp";

export const accommodation = [
  {
    id: "acc-doubletwin",
    name: "Double / twin bedroom \u2014 shared luxury manor house",
    price: 270,
    unit: "Room",
    nights: "3 nights \u00b7 Friday to Monday",
    sleeps: "Sleeps 2",
    image: `${L32}20158/bedroom-5_2026-07-07-154942_lwzv.webp`,
    gallery: [
      `${L32}20158/bedroom-5_2026-07-07-154942_lwzv.webp`,
      `${L32}20177/bedroom-6_2026-07-07-155642_tsrt.webp`,
      EXT12,
    ],
    blurb: "Light-filled room in the heart of the manor.",
    longDesc:
      "A calm, light-filled room in the main manor house, configured as a double or two singles. Perfect for couples or friends who want to be at the heart of the weekend, with the communal lounges and gardens just steps away.",
    features: [
      "Double or twin bed configuration",
      "Inside the shared manor house",
      "8 acres of gardens & woodland",
    ],
  },
  {
    id: "acc-cottage",
    name: "1 bed cottage \u2014 entire cottage",
    price: 370,
    unit: "Cottage",
    nights: "3 nights \u00b7 Friday to Monday",
    sleeps: "Sleeps 2",
    image: `${L32}20176/bedroom-1_2026-07-07-155637_zumu.webp`,
    gallery: [
      `${L32}20176/bedroom-1_2026-07-07-155637_zumu.webp`,
      `${L32}20178/bedroom-8_2026-07-07-155648_rlsr.webp`,
      EXT36,
    ],
    blurb: "Your own private, self-contained cottage.",
    longDesc:
      "Your own private cottage within the estate grounds \u2014 a self-contained retreat with its own living space, ideal if you'd like a little more independence while still being part of everything FERAL Fest has to offer.",
    features: [
      "Entire private cottage to yourselves",
      "Own living space & kitchenette",
      "Cosy log fire",
    ],
  },
  {
    id: "acc-bell",
    name: "Double Glamping Bell Tent",
    price: 330,
    unit: "Tent",
    nights: "3 nights \u00b7 Friday to Monday",
    sleeps: "Sleeps 2",
    image: `${L32}20166/GLAMPING.webp`,
    gallery: [
      `${L32}20166/GLAMPING.webp`,
      `${L32}20167/GLMAPING-bell-tents.webp`,
      EXT12,
    ],
    blurb: "Camping comfort, out on the lawns.",
    longDesc:
      "Sleep out among the lawns in a fully dressed bell tent, complete with a proper double bed, soft rugs and warm lantern light. The closest you'll get to camping without giving up comfort.",
    features: [
      "Fully dressed with a real double bed",
      "Rugs, lanterns & soft furnishings",
      "Shared washroom & shower facilities",
      "Right in the middle of the festival grounds",
    ],
  },
  {
    id: "acc-supreme",
    name: "Supreme double en-suite \u2014 shared luxury manor",
    price: 290,
    unit: "Room",
    nights: "3 nights \u00b7 Friday to Monday",
    sleeps: "Sleeps 2",
    soldOut: true,
    image: "/accommodation/supreme-bedroom.jpg",
    gallery: [
      "/accommodation/supreme-bedroom.jpg",
      "/accommodation/supreme-shower.jpg",
      "/accommodation/supreme-bath.jpg",
    ],
    blurb: "Our most generous manor room, with private en-suite.",
    longDesc:
      "Our most generous manor room, with a private en-suite and premium finishes. A restful sanctuary to return to after a full day of movement, sound and connection.",
    features: [
      "Private en-suite bathroom",
      "Premium double room",
      "Inside the shared manor house",
    ],
  },
  {
    id: "acc-ensuite3",
    name: "En-suite bedroom, 1 single & 1 double, sleeps 3 \u2014 shared manor",
    price: 320,
    unit: "Room",
    nights: "3 nights \u00b7 Friday to Monday",
    sleeps: "Sleeps 3",
    image: "/accommodation/ensuite3-double.jpg",
    gallery: [
      "/accommodation/ensuite3-double.jpg",
      "/accommodation/ensuite3-single.jpg",
      "/accommodation/ensuite3-shower.jpg",
    ],
    blurb: "Spacious en-suite for small groups of three.",
    longDesc:
      "A spacious en-suite room with both a double and a single bed \u2014 great for small groups, families or three friends sharing. Right inside the manor with everything on your doorstep.",
    features: [
      "Sleeps 3 (1 double + 1 single)",
      "Private en-suite bathroom",
      "Inside the shared manor house",
    ],
  },
  {
    id: "acc-offsuite",
    name: "Off-suite double / twin bedroom \u2014 shared luxury manor house",
    price: 240,
    unit: "Room",
    nights: "3 nights \u00b7 Friday to Monday",
    sleeps: "Sleeps 2",
    image: "/accommodation/offsuite-bedroom.jpg",
    gallery: [
      "/accommodation/offsuite-bedroom.jpg",
    ],
    blurb: "Manor comfort with a private bathroom across the hall.",
    longDesc:
      "A comfortable double or twin room in the manor with its own private bathroom located just across the hall. All the warmth of the manor at a friendlier price.",
    features: [
      "Double or twin bed configuration",
      "Private bathroom just across the hall",
      "Inside the shared manor house",
    ],
  },
  {
    id: "acc-campervan",
    name: "Pitch for Campervan or Touring Caravan",
    price: 150,
    unit: "Pitch",
    nights: "3 nights \u00b7 Friday to Monday",
    sleeps: "Bring your own",
    image: `${L32}20167/GLMAPING-bell-tents.webp`,
    gallery: [
      `${L32}20167/GLMAPING-bell-tents.webp`,
      `${L32}20166/GLAMPING.webp`,
      EXT36,
    ],
    blurb: "Park up for the weekend with hook-up & facilities.",
    longDesc:
      "Bring your own campervan or touring caravan and park up for the weekend with electric hook-up and access to shared facilities. Roll out of bed and straight into the festival.",
    features: [
      "Grass / hardstanding pitch",
      "Electric hook-up included",
      "Shared washroom & shower facilities",
      "Full access to the festival site",
      "Bring your own van or caravan",
    ],
  },
];


// ---- The Team page data ----

export const teamPage = {
  heroImage:
    "/legacy/_landscape2391/3396/Feral-Retreat-110_WR.webp",
  heroEyebrow: "THE PEOPLE BEHIND FERAL",
  heroTitle: "Meet the team",
  founderStory: {
    image:
      "/legacy/_instagramPost/4335/Tom-headshot.webp",
    heading: "Tom's story starts with hitting a wall.",
    paragraphs: [
      "After years of building, searching and not being able to name what was missing, Tom reached his lowest point. What followed was therapy, deep inner work, and a rebuilding that changed everything, not just his life, but his entire lens on what was possible. For the first time he felt able to fulfil his wildest dreams.",
      "From that process came the FERAL cycle. He lived it before he built it.",
      "Today he is building a movement he wishes had existed when he needed it most.",
    ],
  },
  accentImage:
    "/legacy/_landscape169/3654/pineapples-HD.webp",
  teamEyebrow: "THE FERAL TEAM",
  teamHeading: "Built by people who live it.",
  teamIntro:
    "Our core FERAL team lead from the front. Around them, a handpicked network who share the same vision and support every Tribe experience and event.",
  members: [
    {
      name: "Tom",
      role: "Founder and Lead Dreamer",
      bio: "The visionary behind FERAL, Tom is a property expert whose own story showed him the power of connecting with yourself, with nature and with each other.",
      image: "/legacy/_instagramPost/4335/Tom-headshot.webp",
    },
    {
      name: "Anneka",
      role: "Co-Founder and CEO",
      bio: "Property expert, numbers brain and Pilates instructor. The steady hand behind FERAL.",
      image: "/legacy/_instagramPost/4502/WhatsApp-Image-2026-03-20-at-10.58.06.webp",
    },
    {
      name: "Naomi",
      role: "Creative Director",
      bio: "A true artist with a designer's eye, behind everything FERAL looks and feels like.",
      image: "/legacy/_instagramPost/4338/Naomi-headshot.webp",
    },
    {
      name: "Sophie",
      role: "COO",
      bio: "The one who brings the FERAL vision to life, with nearly two decades of hospitality and events experience behind her.",
      image: "/innov-sophie.jpg",
    },
    {
      name: "Calum",
      role: "Therapeutic Practitioner",
      bio: "A true holder of space, leading everything from breathwork and meditation to group workshops and one-to-one therapeutic work.",
      image: "/calum.png",
      position: "35% center",
    },
    {
      name: "Aimee",
      role: "Culinary Creator",
      bio: "A wonderfully creative chef who cooks with the seasons and the best local produce, creating unforgettable food for our retreat and corporate guests.",
      image: "/team-aimee.jpg",
      position: "center 20%",
    },
  ],
  collab: {
    eyebrow: "COLLABORATION",
    heading: "Our expanding collective.",
    lead:
      "FERAL is more than a venue. It's a growing collective of facilitators, practitioners and collaborators shaping each gathering.",
    body:
      "Chefs, coaches, musicians, speakers, therapists, artists and guides from across North Wales. Like-minded people, chosen for the depth of their craft.",
    images: [
      {
        src: "/legacy/_landscape32/4493/adventure-exploration.webp",
        label: "Adventure & Exploration",
      },
      {
        src: "/legacy/_landscape32/4491/Wellness-Restoration.webp",
        label: "Wellness & Restoration",
      },
      {
        src: "/legacy/_landscape32/4489/Primal-Feasts.webp",
        label: "Primal Feasts",
      },
    ],
  },
};


// ---- Feral Stays data ----

const FT = "/legacy/";

export const feralStays = {
  heroImage: `/bron-menai.jpeg`,
  heroEyebrow: "FERAL STAYS",
  heroTitle: "Our magical Anglesey venues",
  heroIntro:
    "Now managed entirely in-house by FERAL. Two owned estates on the wild edge of Anglesey \u2014 designed for depth, built for gathering, and yours to make your own.",
  venues: [
    {
      slug: "plas-llechylched",
      name: "Plas Llechylched",
      location: "Rhosneigr, Anglesey",
      sleeps: "20 bedrooms \u00b7 sleeps up to 40",
      tagline: "A historic courtyard estate, reimagined.",
      heroImage: `/plas-exterior.jpeg`,
      cardImage: `/plas-exterior.jpeg`,
      description:
        "A historic courtyard estate reimagined by FERAL. Private cottages, shared spaces and 20 bedrooms anchored by log fires, hot tubs and slow, communal living. Set moments from wild beaches and open fields, with uninterrupted horizons and cinematic sunsets. Rustic spa rituals, outdoor feasting, fire pits and a wild pond invite you to switch off. Roamed by our resident goats, the FERAL Mowers, this is a place to gather, reset and reconnect.",
      gallery: [
        `/plas-exterior.jpeg`,
        `/plas-interior.jpg`,
        `${FT}_landscape169/4515/Photo-3.webp`,
        `${FT}_landscape169/4354/DSC2939.webp`,
        `${FT}_landscape169/4355/DSC2943.webp`,
        `${FT}_landscape169/4356/DSC4461.webp`,
        `${FT}_landscape169/4357/DSC4734.webp`,
      ],
      facilities: [
        "20 bedrooms across cottages & manor",
        "Sleeps up to 40 guests",
        "Log fires throughout",
        "Hot tubs",
        "Rustic spa rituals",
        "Outdoor feasting & fire pits",
        "Wild pond",
        "Resident goats \u2014 the FERAL Mowers",
        "Moments from wild beaches",
      ],
      cottages: [
        {
          name: "The Whole Estate",
          sleeps: "Sleeps up to 40 \u00b7 20 bedrooms",
          image: `${FT}_landscape169/4515/Photo-3.webp`,
          desc: "Exclusive use of the entire courtyard estate \u2014 every cottage, every shared space \u2014 for large groups, celebrations and full FERAL retreats.",
        },
        {
          name: "The Courtyard Cottages",
          sleeps: "Sleeps 2\u20136 each",
          image: `${FT}_landscape169/4354/DSC2939.webp`,
          desc: "Self-contained private cottages wrapped around the courtyard. Their own front doors, log fires and slow mornings \u2014 ideal for couples and small groups.",
        },
        {
          name: "The Farmhouse & Shared Spaces",
          sleeps: "Sleeps up to 14",
          image: `${FT}_landscape169/4356/DSC4461.webp`,
          desc: "The communal heart of the estate: big kitchen, gathering lounges, log fires and long dining tables made for feasting together.",
        },
      ],
    },
    {
      slug: "bron-menai",
      name: "Bron Menai",
      location: "Newborough, Anglesey",
      sleeps: "Manor sleeps 15 \u00b7 up to 23 with cottages",
      tagline: "The ultimate wellness country manor.",
      heroImage: `/bron-menai.jpeg`,
      cardImage: `/bron-menai.jpeg`,
      description:
        "A fully renovated country manor set within eight acres of unspoilt Anglesey landscape. The manor sleeps 15, with additional cottages bringing capacity to 23. Generous living spaces, indoor and outdoor dining, and a light-filled studio set within the walled garden. A wellness suite with sauna, cold plunge, hot tub and a quiet Zen den for treatments supports rest, focus and reset. Positioned four miles from Anglesey's famous Newborough beach and forest.",
      gallery: [
        `/bron-menai.jpeg`,
        `${FT}_landscape2391/14897/8595794-exterior36-800_2026-06-22-165222_udgz.webp`,
        `${FT}_landscape2391/14901/WhatsApp-Image-2026-06-22-at-17.51.16-1.webp`,
        `${FT}_landscape32/20176/bedroom-1_2026-07-07-155637_zumu.webp`,
        `${FT}_landscape32/20153/bath-bedroom_2026-07-07-154938_iphl.webp`,
      ],
      facilities: [
        "Manor sleeps 15 (up to 23 with cottages)",
        "Every bedroom en-suite",
        "Wellness suite: sauna & cold plunge",
        "Hot tub & Zen treatment den",
        "Meditation space",
        "Light-filled walled-garden studio",
        "8 acres of grounds",
        "4 miles from Newborough beach & forest",
      ],
      cottages: [
        {
          name: "The Manor House",
          sleeps: "Sleeps 15 \u00b7 all en-suite",
          image: `${FT}_landscape2391/14897/8595794-exterior36-800_2026-06-22-165222_udgz.webp`,
          desc: "The full country manor \u2014 en-suite bedrooms, generous living and dining spaces, a garden studio and the basement wellness suite with sauna and cold plunge.",
        },
        {
          name: "The Garden Cottages",
          sleeps: "Up to 6 extra guests",
          image: `${FT}_landscape32/20176/bedroom-1_2026-07-07-155637_zumu.webp`,
          desc: "Additional cottages within the grounds, bringing total capacity to 23 \u2014 perfect for larger groups who still want their own private space.",
        },
      ],
    },
  ],
  retreatSection: {
    eyebrow: "BOOK A RETREAT",
    heading: "Escapes with purpose",
    intro:
      "Premium escapes rooted in the wild beauty of North Wales. Designed for groups and solo guests alike, each retreat invites you to embrace your passion and reconnect with yourself. Choose an experience, choose your dates, and enquire \u2014 we'll handle the rest.",
    retreats: [
      {
        title: "Nature Retreat",
        image: `${FT}_landscape169/4358/Feral-Retreat-3_WR_2026-03-19-150724_dpim.webp`,
        desc: "Anglesey is an Area of Outstanding Natural Beauty with nature reserves and some of the darkest skies for stargazing. Slow down, walk the coast, watch the wildlife and reconnect with the land.",
      },
      {
        title: "Watersports Retreat",
        image: `${FT}_landscape169/4360/Feral-Retreat-85_WR_2026-03-19-150727_cmlw.webp`,
        desc: "The island is a watersports playground. Sail, surf, paddle or coasteer your way around the coastline with our trusted local guides.",
      },
      {
        title: "Wellness Retreat",
        image: `${FT}_landscape169/4362/Feral-Retreat-140_WR_2026-03-19-150730_nivn.webp`,
        desc: "Salt air, open landscapes and sensory healing. Our wellness retreats use the power of nature to strip away the noise and leave you re-energised.",
      },
      {
        title: "Fitness Retreat",
        image: `${FT}_landscape169/4364/Feral-Retreat-163_WR_2026-03-19-150732_otwl.webp`,
        desc: "A holistic, feel-good approach to movement in a wild setting. Yoga, pilates, strength or a sport of your choice \u2014 designed around you.",
      },
    ],
  },
};


// ---- Earn & Enjoy (investment rewards) data ----

const EE = "/legacy/";

export const earnEnjoy = {
  heroImage: `${EE}_landscape169/3644/Men-2.webp`,
  heroEyebrow: "BECOME A FERAL PARTNER",
  heroTitle: "The Vision",
  heroIntro:
    "Become part of the movement you love. Put capital into FERAL's growth \u2014 new venues, events and experiences \u2014 and get rewarded in the currency that matters most: time in wild places, festival weekends, and a tribe that feels like home.",
  benefits: [
    { icon: "BedDouble", text: "FERAL credits to spend at FERAL stays and events" },
    { icon: "Ticket", text: "Free festival tickets all year round" },
    { icon: "Users", text: "Invitations to exclusive events" },
    {
      icon: "Sparkles",
      text: "Property, business & therapy coaching from Tom and the coaching team",
    },
    {
      icon: "Trees",
      text: "Host your own free retreat — full use of the entire site for your people",
    },
  ],
  steps: [
    {
      icon: "HandCoins",
      title: "Invest",
      desc: "Choose a tier and invest into FERAL's expansion across Anglesey and beyond.",
    },
    {
      icon: "Sparkles",
      title: "Earn",
      desc: "Each year your investment earns FERAL Credits, redeemable against stays and festivals.",
    },
    {
      icon: "Ticket",
      title: "Enjoy",
      desc: "Spend credits on free nights at our estates, festival passes and member experiences.",
    },
    {
      icon: "Leaf",
      title: "Grow",
      desc: "As FERAL grows, so do your rewards. Reinvest, gift your credits, or let your perks compound.",
    },
  ],
  tiers: [
    {
      name: "Seed",
      icon: "Sprout",
      amount: "\u00a32,500",
      amountNote: "one-off investment",
      targetReturn: "Target up to 5% p.a.*",
      highlight: false,
      perks: [
        "2 festival day tickets each year",
        "2 free nights at a FERAL Stay each year",
        "Member-only gatherings",
        "Early access to all events",
      ],
    },
    {
      name: "Grove",
      icon: "Trees",
      amount: "\u00a310,000",
      amountNote: "one-off investment",
      targetReturn: "Target up to 6% p.a.*",
      highlight: true,
      badge: "Most popular",
      perks: [
        "1 FERAL Fest weekend pass for two, each year",
        "5 free nights at a FERAL Stay each year",
        "10% off all events & retreats",
        "Priority booking on new dates",
        "Member-only gatherings",
      ],
    },
    {
      name: "Wildland",
      icon: "Mountain",
      amount: "\u00a325,000",
      amountNote: "one-off investment",
      targetReturn: "Target up to 7% p.a.*",
      highlight: false,
      perks: [
        "4 FERAL Fest weekend passes each year",
        "A free weekend cottage stay each year",
        "All-access festival pass",
        "20% off retreats & experiences",
        "Invitations to founder circles",
      ],
    },
    {
      name: "Founding Guardian",
      icon: "Crown",
      amount: "\u00a350,000+",
      amountNote: "founding investment",
      targetReturn: "Target up to 8% p.a.* + revenue share",
      highlight: false,
      perks: [
        "Unlimited festival access",
        "A free week-long stay each year",
        "One whole-estate exclusive-use weekend",
        "Named recognition at our venues",
        "A seat at the FERAL table \u2014 help shape what we build",
      ],
    },
  ],
  rewards: [
    { icon: "Ticket", title: "Free festival weekends", desc: "Redeem credits for FERAL Fest passes \u2014 for you and your people." },
    { icon: "BedDouble", title: "Free nights at our estates", desc: "Stay at Plas Llechylched or Bron Menai on us." },
    { icon: "Star", title: "Priority booking & early access", desc: "First dibs on new dates, events and releases." },
    { icon: "Users", title: "Member-only gatherings", desc: "Intimate socials, suppers and seasonal rituals." },
    { icon: "Percent", title: "Discounts on retreats", desc: "Save on retreats, experiences and add-ons all year." },
    { icon: "Gift", title: "Bring-a-friend guest passes", desc: "Share the magic \u2014 gift stays and passes to friends." },
  ],
  faqs: [
    {
      q: "Is my investment guaranteed?",
      a: "No. Investing carries risk and your capital is at risk. Earn & Enjoy rewards are experiential perks rather than a guaranteed financial return. We'll walk you through everything before you commit.",
    },
    {
      q: "What about the target returns you show?",
      a: "The percentages shown are illustrative targets only \u2014 they are not guaranteed, not a forecast, and could be lower or nil. Any actual return depends entirely on FERAL's performance. You should never invest based on the target figure alone.",
    },
    {
      q: "How do FERAL Credits work?",
      a: "Credits are issued to you each year based on your tier, and can be redeemed against stays and festival tickets, subject to availability.",
    },
    {
      q: "Can I gift my rewards?",
      a: "Yes \u2014 credits and guest passes can be shared with friends and family, so you can bring your people along.",
    },
    {
      q: "How do I get started?",
      a: "Register your interest below and our team will arrange a call to talk through the tiers, the vision and the paperwork.",
    },
  ],
  riskWarning:
    "Don't invest unless you're prepared to lose all the money you invest. This is a high-risk investment and you are unlikely to be protected if something goes wrong.",
  returnsNote:
    "*Target returns are illustrative only, not guaranteed, and could be lower or nil. They are shown before any fees and are not a forecast. Past performance does not predict future results. Rewards and any return depend on FERAL's performance \u2014 your capital is at risk and you may get back less than you invest.",
  disclaimer:
    "FERAL Earn & Enjoy is an illustrative membership concept shown for demonstration only. It is not an offer, invitation or inducement to invest, and it is not financial advice or an approved financial promotion. Any live offer would be made through the proper documentation and, where required, approved by a firm authorised by the Financial Conduct Authority (FCA). Investments of this kind put your capital at risk, are illiquid, and are not covered by the Financial Services Compensation Scheme (FSCS). Please seek independent financial advice before investing.",
};


// ---- RAF Valley Families Day (community fundraiser at Hotel Cymyran) ----

const CY = "/legacy/";

export const rafValleyDay = {
  slug: "raf-valley-family-day",
  name: "RAF Valley Families Day",
  subtitle: "A community gathering at Hotel Cymyran",
  category: "Community Fundraiser",
  tag: "For everyone",
  dateLine: "Friday 7th August '26",
  time: "10:00 \u2013 16:00",
  venue: "Hotel Cymyran, next to RAF Valley, Anglesey",
  priceFrom: "Parking \u00a318 \u00b7 all profits to charity",
  charity: "Suicide Prevention UK",
  cardImage: `/cymyran-exterior.png`,
  images: [
    `${CY}_square/4332/Cymyran.webp`,
    "https://images.unsplash.com/photo-1689182314475-ff55f109b430",
    "https://images.unsplash.com/photo-1503348379917-758650634df4",
  ],
  description: [
    "FERAL is proud to host a community day at Hotel Cymyran \u2014 our home right beside RAF Valley \u2014 on the day of the RAF Valley Families Day.",
    "Park with us for the day and every penny of profit goes to Suicide Prevention UK. It's a simple way to look out for one another, because connection saves lives and no one should face the hard days alone.",
    "Roll up, park up and stay a while. Our grounds will be alive with food trucks, a coffee van and an ice cream van, hay bales to sprawl on, face painting and a bouncy castle for the little ones \u2014 a warm, welcoming space for families, friends and the whole community to gather.",
    "This is FERAL doing what we do best: bringing people together in the wild heart of Anglesey, for something bigger than ourselves.",
  ],
  whatsOn: [
    { icon: "Truck", label: "Food trucks" },
    { icon: "Coffee", label: "Coffee van" },
    { icon: "IceCream", label: "Ice cream van" },
    { icon: "Wheat", label: "Hay bales to gather on" },
    { icon: "Palette", label: "Face painting" },
    { icon: "PartyPopper", label: "Bouncy castle" },
  ],
  parking: {
    id: "parking",
    name: "Event Parking at Hotel Cymyran",
    price: 18,
    unit: "Vehicle",
    desc: "All-day parking on-site at Hotel Cymyran, moments from the RAF Valley Families Day. One ticket covers one vehicle for the day.",
  },
  donationPresets: [0, 5, 10, 20],
  donationNote:
    "100% of profits go to Suicide Prevention UK. If you're able to, add a little extra \u2014 every pound helps someone through a hard day.",
};

// Summary list used on the /events page
export const eventsList = [
  {
    slug: "feral-fest",
    cardImage: "/feralfest-bron.jpeg",
    tag: "Open to all",
    category: `Empowerment Festival \u00b7 ${feralFest.subtitle}`,
    name: feralFest.name,
    dateLine: feralFest.dateLine,
    venue: feralFest.venue,
    priceFrom: feralFest.priceFrom,
  },
  {
    slug: rafValleyDay.slug,
    cardImage: rafValleyDay.cardImage,
    tag: rafValleyDay.tag,
    category: rafValleyDay.category,
    name: rafValleyDay.name,
    dateLine: rafValleyDay.dateLine,
    venue: rafValleyDay.venue,
    priceFrom: rafValleyDay.priceFrom,
  },
];

